import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAvailablePlans as GetAvailablePlansQuery,
    GetAvailablePlans_recurlyAvailablePlans_crm as Crm,
    GetAvailablePlans_recurlyAvailablePlans_marketing as Marketing,
    GetAvailablePlans_recurlyAvailablePlans_revenueBooster as RevenueBooster,
    GetAvailablePlans_recurlyAvailablePlans_nutshellIq as NutshellIq,
    GetAvailablePlans_recurlyAvailablePlans_smsCampaigns as SmsCampaigns,
    GetAvailablePlans_recurlyAvailablePlans_inbox as Engagement,
    GetAvailablePlans_recurlyAvailablePlans_marketingSuite as MarketingSuite,
    GetAvailablePlans_recurlyAvailablePlans_quotes as Quotes,
    GetAvailablePlans_recurlyAvailablePlans_nutshellAdvisor as NutshellAdvisor,
} from 'nutshell-graphql-types';

import GET_AVAILABLE_PLANS from '../queries/get-available-plans.graphql';

export type AddOns = {
    marketing: Marketing;
    revenueBooster: RevenueBooster;
    nutshellIq: NutshellIq;
    smsCampaigns: SmsCampaigns;
    quotes: Quotes;
    nutshellAdvisor: NutshellAdvisor;
};

export const useGetAvailablePlans = (
    shouldSkip?: boolean
): {
    addOns: AddOns | null | undefined;
    crm: Crm | null | undefined;
    engagement: Engagement | null | undefined;
    marketingSuite: MarketingSuite | null | undefined;
    isLoading: boolean;
    errorMessage: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {data, loading, error, refetch} = useQuery<GetAvailablePlansQuery, Record<any, any>>(
        GET_AVAILABLE_PLANS,
        {
            fetchPolicy: 'cache-and-network',
            skip: shouldSkip,
        }
    );

    const recurlyAvailablePlans = data ? data.recurlyAvailablePlans : null;

    const crm = recurlyAvailablePlans ? recurlyAvailablePlans.crm : null;
    const engagement = recurlyAvailablePlans ? recurlyAvailablePlans.inbox : null;
    const marketingSuite = recurlyAvailablePlans ? recurlyAvailablePlans.marketingSuite : null;

    const addOns = recurlyAvailablePlans
        ? {
              marketing: recurlyAvailablePlans.marketing,
              revenueBooster: recurlyAvailablePlans.revenueBooster,
              nutshellIq: recurlyAvailablePlans.nutshellIq,
              smsCampaigns: recurlyAvailablePlans.smsCampaigns,
              quotes: recurlyAvailablePlans.quotes,
              nutshellAdvisor: recurlyAvailablePlans.nutshellAdvisor,
          }
        : null;

    return {
        addOns,
        crm,
        engagement,
        marketingSuite,
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
